import { gql } from '@apollo/client';

export const TREATMENT = gql`
  fragment Treatment on Treatment {
    id
    name
    description
    reconOrder
  }
`;
